import React, { HTMLAttributeAnchorTarget } from "react";
import "./Button.css";

type ButtonProps = {
  children?: React.ReactNode;
  disabled?: boolean;
  onClick?(): void;
  buttonClass?: "primary" | "secondary" | "link";
  className?:string;
  text:string
  target?: HTMLAttributeAnchorTarget | undefined;
  href?:string
};

const onMouseEnter = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, color:string,bgColor:string) => {
  const targetElem = (event.target as HTMLInputElement);
  targetElem.style.backgroundColor = color;
  targetElem.style.backgroundColor = bgColor;
};

const onMouseOut = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, color:string,bgColor:string) => {
  const targetElem = (event.target as HTMLInputElement);
  targetElem.style.backgroundColor = color;
  targetElem.style.backgroundColor = bgColor;
};

export default function Link({
  children,
  disabled,
  onClick,
  buttonClass = "primary",
  className,
  text,
  target,
  href,
	}: ButtonProps) {
  return (
    <div className={className}>
      <a
        className="main-button"
        href={href}
        target={target && "_blank"}>
        {text}
      </a>
    </div>
  );
}